import ApiService from '../api.service';

const PresenceList = {
  index: () => ApiService.get('/api/v2/principals/me/presence_lists'),
  show: params => ApiService.get(`/api/v2/principals/me/presence_lists/${params}`),
  listAbsenceByStudent: params => ApiService.query('/api/v2/principals/me/presence_lists/absences_by_student/', params),
};

export default PresenceList;
